module.exports = __webpack_public_path__ + "img/矩形 80@1x.bf2e631c.png";